import { render, staticRenderFns } from "./MailCheck.vue?vue&type=template&id=551372be&scoped=true&"
import script from "./MailCheck.vue?vue&type=script&lang=js&"
export * from "./MailCheck.vue?vue&type=script&lang=js&"
import style0 from "./MailCheck.vue?vue&type=style&index=0&id=551372be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551372be",
  null
  
)

export default component.exports